import { render, staticRenderFns } from "./PendingDomainListItem.vue?vue&type=template&id=1a21ea46&"
import script from "./PendingDomainListItem.vue?vue&type=script&lang=js&"
export * from "./PendingDomainListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports